<template>
  <div>
    <p v-html="requisitoTexto"></p>

    <h5 class="text-azul font-weight-bold">
      Nivel requisito de ingreso: {{ nivelRequisito }}
    </h5>

    <!-- ponderaciones -->
    <h5 class="text-azul font-weight-bold my-4">Ponderaciones:</h5>

    <Ponderaciones :ponderaciones="ponderaciones" />

    <h5 class="text-azul font-weight-bold my-3">Información Adicional:</h5>

    <ul class="req-list">
      <li
        class="caps"
        v-show="
          requisitos.minimoPuntajePostulacion &&
            requisitos.minimoPuntajePostulacion !== ''
        "
      >
        Puntaje promedio Comprensión Lectora y Matemática mínimo de postulación
        de
        <strong>{{ requisitos.minimoPuntajePostulacion }}</strong> puntos.
      </li>
      <li
        v-show="
          requisitos.minimoPuntajePonderado &&
            requisitos.minimoPuntajePonderado !== ''
        "
      >
        Puntaje promedio ponderado mínimo de postulación de
        <strong>{{ requisitos.minimoPuntajePonderado }}</strong> puntos.
      </li>
      <li
        v-show="
          requisitos.maximoPostulaciones &&
            requisitos.maximoPostulaciones !== ''
        "
      >
        Se considera hasta la
        <strong>{{ textoMaximoPostulaciones }}</strong> de postulación. Las
        postulaciones a esta carrera ingresadas a continuación de ésta, no serán
        consideradas.
      </li>
      <li
        v-show="
          requisitos.exclusionesPorPreferencia &&
            requisitos.exclusionesPorPreferencia !== ''
        "
      >
        Se permite postular a un máximo de
        <strong>{{ textoExclusionesPorPreferencia }}</strong> en la misma
        institución.
      </li>
      <li v-show="requisitos.exclusion10">
        La Universidad
        <strong>{{ textoExclusion10 }}</strong> la opción de postulación a
        estudiantes que no cumplan con 458 puntos promedio, pero que pertenezcan
        al 10% superior de su establecimiento educacional.
      </li>
      <li
        v-for="requisito in requisitos.otrosRequisitos"
        :key="requisito.index"
      >
        {{ requisito }}
      </li>
    </ul>
  </div>
</template>

<script>
import Ponderaciones from "@/components/fichaCarreraU/Ponderaciones";

export default {
  name: "RequisitosIngreso",
  props: {
    requisitos: {
      type: Object
    },
    requisitoTexto: {
      type: String
    },
    ponderaciones: {
      type: Object
    },
    nivelRequisito: {
      type: String
    }
  },
  components: {
    Ponderaciones
  },
  computed: {
    textoMaximoPostulaciones() {
      if (this.requisitos.maximoPostulaciones !== "") {
        return `${this.requisitos.maximoPostulaciones}° PREFERENCIA`;
      }
    },
    textoExclusionesPorPreferencia() {
      if (this.requisitos.exclusionesPorPreferencia !== "") {
        return `${this.requisitos.exclusionesPorPreferencia} CARRERAS`;
      }
    },
    textoExclusion10() {
      if (this.requisitos.exclusion10 !== "") {
        let text;
        if (
          this.requisitos.exclusion10 === "SI" ||
          this.requisitos.exclusion10 === "SÍ"
        ) {
          text = `ACEPTA`;
        } else {
          text = `${this.requisitos.exclusion10} ACEPTA`;
        }
        return text.toLowerCase();
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/fichaCarreraU/RequisitosIngreso.vue